const EntityStore = require("stores/abstract/EntityStore");
const axios = require("axios");
const router = require("services/router");
const env = require("services/env");
const assign = require("object-assign");
const {reportAndThrow} = require("helpers/errors");

class UserStore extends EntityStore {

	get endpoint() {
		return router.route("api.profiles.update", {profile_id: this.attributes.id});
	}

	upgrade() {
		return axios
			.patch(router.route("api.profiles.upgrade", {profile_id: this.attributes.id}))
			.then(response => {
				assign(this.attributes, response.data);
				return this;
			})
			.catch(reportAndThrow);
	}

	refresh() {
		return axios
			.get(router.route("api.profiles.get", {profile_id: this.attributes.id}))
			.then(response => {
				assign(this.attributes, response.data);
				return this;
			})
			.catch(reportAndThrow);
	}
}

module.exports = new UserStore(env.get("stores.user", {}));



// WEBPACK FOOTER //
// ./resources/js/stores/UserStore.js